// extracted by mini-css-extract-plugin
export default {"list":"go3Ks","loadingIndicator":"R2dRF"};